export enum EBillingSubTab {
	CLAIMS = 'claims',
	MEMBERS = 'members',
}

export type BillingView = 'claims' | 'aggregation' | 'members';

export interface IBillingState {
	// page per view, so master (aggregation) and detail (members) do not share it
	pages: Record<BillingView, number>;
	// sort of the master saved when opening the detail, restored when coming back
	masterSort: { name: string; value: string } | null;
	totalPages: number;
	tabSelected: 'claims' | 'admin';
	subTabSelected: EBillingSubTab;
	claimsBilling: IClaimBilling[];
	memberAggregationBilling: IMemberAggregationBilling[];
	membersBilling: IMemberBilling[];
	claimsBillingStatuses: IBillingStatus[];
	adminBillingStatuses: IBillingStatus[];
	groups: ISelectData[];
	billingTypologies: IBillingType[];
	membersBillingMonths: ISelectData[];
	planCodes: ISelectData[];
	planCodesDomain: IPlanDomain[];
}

export interface IBillingType {
	code: string;
	description: string;
	label: string;
	billType: string;
}

export interface ISelectData {
	code: string;
	name: string;
	knownAsName?: string;
}

export interface ICarrierDomain {
	code: string;
	name: string;
	knownAsName: string;
	externalIntegrationFlow: string | null;
	customLayout: string | null;
}

export interface IClientDomain {
	code: string;
	name: string;
	externalClientId: string;
	carrier: ICarrierDomain;
}

export interface IGroupDomain {
	code: string;
	name: string;
	externalGroupId: string;
	client: IClientDomain;
}

export interface IPlanDomain {
	code: string;
	name: string;
	externalPlanId: string;
	group: IGroupDomain;
}

export interface IBillingStatus {
	code: string;
	label: string;
}

export interface IClaimBilling {
	billingId: string;
	client: string;
	carrier: string;
	group: string;
	claimNumber: string;
	claimDate: string;
	paidDate: string;
	billingDate: string;
	settlementDate: string;
	billingType: IBillingType;
	claimStatus: IBillingStatus;
	claimBillingStatus?: IBillingStatus;
	adminBillingStatus?: IBillingStatus;
	claimUuid: string;
	carrierClaimId: string;
	carrierDocument: ICarrierDocument;
	inNetwork: boolean;
	networkCode: string;
}

export interface IMemberAggregationBilling {
	id: number;
	carrierCode: string;
	carrierName: string;
	billingMonth: string;
	clientCode: string;
	clientName: string;
	groupCode: string;
	groupName: string;
	planCode: string;
	planDescription: string;
	billingRate: number;
	memberCount: number;
	totalAmount: number;
}
export interface IMemberBilling {
	adminBillingStatus?: IBillingStatus;
	adminClaimBillingRun: string;
	billedSapId: string;
	billingId: string;
	billingMonth: string;
	billingType: IBillingType;
	carrierName: string;
	clientName: string;
	divisionCode: string;
	externalMemberId: string;
	groupName: string;
	memberEyemedId: string;
	memberName: string;
	memberSurname: string;
	memberUuid: string;
	networkCode: string;
	planName: string;
	rateAmount: number;
	relationshipCode: string;
	subscriptionStart: string;
	subscriptionEnd: string;
}

export interface ICarrierDocument {
	uuid: string;
	code: string;
	name: string;
}

export interface IBillingType {
	billType: string;
	billTypeLabel: string;
	code: string;
	label: string;
}

export type TBillingStatus =
	| 'not_billed'
	| 'sent_for_billing'
	| 'billed'
	| 'settled'
	| 'billed_mismatched'
	| 'rebilled';

//TODO: this should come from an API endpoint
export type BILLING_STATUSES =
	| 1 // not billed
	| 2 // sent_for_billing
	| 3 // billed
	| 4 // settled
	| 5 // billed_mismatched
	| 6; // rebilled;
